'use client';
import { useMediaQuery } from './useMediaQuery';

export const MOBILE_VIEWPORT_QUERY =
  '(orientation: portrait) and (max-width: 768px), (orientation: landscape) and (max-width: 1024px)';

export const useIsMobile = () => useMediaQuery(MOBILE_VIEWPORT_QUERY);
